import { FC } from 'react';
import { Image, Stack, VStack } from '@chakra-ui/react';

import { FeatureName } from '__generated__/GQL';
import cardImg from 'assets/brand/credit-card.png';
import useCanCompanyUserAccessFeature from 'common/hooks/useCanCompanyUserAccessFeature';
import Text from 'components/_core/Text';

import locales from './locales';

const PaymentCardListEmptyState: FC = () => {
  const { canAccessFeature } = useCanCompanyUserAccessFeature();

  return (
    <VStack align="center" gap="space-24">
      <Image src={cardImg} width={120} />
      <Stack gap="space-16">
        <Text
          fontWeight="weight-500"
          size="lg"
          textAlign="center"
          variant="primary"
        >
          {locales.title}
        </Text>
        <Text variant="secondary">
          {canAccessFeature({ name: FeatureName.PaymentcardsOrder })
            ? locales.subtitle
            : locales.employeeSubtitle}
        </Text>
      </Stack>
    </VStack>
  );
};

export default PaymentCardListEmptyState;
